import React, { createContext } from 'react';

const PremPlayersContext = createContext();

export default PremPlayersContext;